import { useMemo } from 'react';
import { IncomeModel, IncomeType, IncomeDTO, useIncomeQuery } from './api/useIncomeQuery';
import { AsyncComponentHookResult } from '../../Types/ComponentHookResult';

export interface IncomeData extends IncomeDTO {
  incomesDict: Record<IncomeType, IncomeModel[]>;
}

interface Params {
  clientId: string;
}

export const useIncome = ({ clientId }: Params): AsyncComponentHookResult<IncomeData> => {
  const queryResult = useIncomeQuery({ clientId });

  const data = useMemo(() => {
    if (!queryResult.data) {
      return null;
    }

    const incomesDict = queryResult.data.Options.IncomeTypeOptions.reduce((acc, income) => {
      acc[income.value] = [];
      return acc;
    }, {} as Record<IncomeType, IncomeModel[]>);

    queryResult.data.Incomes.forEach(income => {
      if (incomesDict[income.IncomeType]) {
        incomesDict[income.IncomeType].push(income);
      }
    });

    return {
      ...queryResult.data,
      incomesDict,
    };
  }, [queryResult.data]);

  return {
    ...queryResult,
    data,
  };
};
